import { createApiClient } from '../../api/apiClient'

export const appendApiKey = (endpoint, apiKey, queryParams = {}) => {
  const url = new URL(endpoint, window.location.origin)

  if (apiKey && !url.searchParams.has('key')) {
    url.searchParams.set('key', apiKey)
  }

  Object.entries(queryParams).forEach(([name, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(name, value)
    }
  })

  return endpoint.startsWith('http')
    ? url.toString()
    : `${url.pathname}${url.search}${url.hash}`
}

export const createBrandApiRequest = ({ apiKey = '', axiosInstance } = {}) => {
  const apiClient = createApiClient({ apiKey, axiosInstance, baseUrl: '' })

  return ({ body, endpoint, method = 'get', queryParams, timeout }) =>
    apiClient[method](appendApiKey(endpoint, apiKey, queryParams), {
      ...(body === undefined ? {} : { body }),
      ...(timeout === undefined ? {} : { timeout }),
    })
}
